export enum ClientFormDynamicFieldsName {
  Emails = 'emails',
  PhoneNumbers = 'phoneNumbers',
}
